import { habitStore } from '../store/habitStore';

export async function renderDashboard(containerId) {
    const container = document.getElementById(containerId);
    if (!container) return;

    const rates = await habitStore.getDailyCompletionRates();
    const today = new Date();

    // Generate last 90 days for the contribution map
    const dates = [];
    for (let i = 89; i >= 0; i--) {
        const d = new Date();
        d.setDate(today.getDate() - i);
        dates.push(d.toISOString().split('T')[0]);
    }

    const totalDays = Object.keys(rates).length;
    const avgRate = totalDays > 0
        ? (Object.values(rates).reduce((a, b) => a + b, 0) / totalDays * 100).toFixed(1)
        : 0;

    container.innerHTML = `
        <div class="animate-in fade-in slide-in-from-bottom-4 duration-700">
            <h2 class="text-3xl font-black text-df-sapphire mb-8">Your Journey</h2>
            
            <div class="grid grid-cols-2 gap-4 mb-10">
                <div class="bg-df-sapphire text-white p-6 rounded-[2rem] shadow-xl shadow-df-sapphire/20">
                    <p class="text-[10px] font-black uppercase tracking-widest opacity-60 mb-1">Average Rate</p>
                    <h4 class="text-3xl font-black">${avgRate}%</h4>
                </div>
                <div class="bg-df-aqua text-df-sapphire p-6 rounded-[2rem] shadow-xl shadow-df-aqua/20">
                    <p class="text-[10px] font-black uppercase tracking-widest opacity-60 mb-1">Total Days</p>
                    <h4 class="text-3xl font-black">${totalDays}d</h4>
                </div>
            </div>

            <section class="mb-10">
                <div class="flex justify-between items-end mb-4 px-2">
                    <h3 class="text-xl font-black text-df-sapphire">Contribution Map</h3>
                    <span class="text-[10px] font-bold text-df-bluegrey uppercase tracking-widest">Last 90 Days</span>
                </div>
                <div class="bg-gray-50/50 p-6 rounded-[2.5rem] border border-gray-100/50 shadow-sm overflow-x-auto">
                    <div class="flex flex-wrap gap-1.5 min-w-[300px]" id="contribution-grid">
                        ${dates.map(date => {
        const rate = rates[date] || 0;
        let colorClass = 'bg-gray-100';
        if (rate > 0.8) colorClass = 'bg-df-aqua';
        else if (rate > 0.5) colorClass = 'bg-df-bluegrey';
        else if (rate > 0) colorClass = 'bg-df-bluegrey/30';

        return `<div class="w-3 h-3 rounded-[3px] ${colorClass}" title="${date}: ${(rate * 100).toFixed(0)}%"></div>`;
    }).join('')}
                    </div>
                    <div class="mt-4 flex items-center justify-end gap-2 text-[8px] font-black text-df-bluegrey uppercase tracking-widest">
                        <span>Less</span>
                        <div class="w-2 h-2 rounded-[2px] bg-gray-100"></div>
                        <div class="w-2 h-2 rounded-[2px] bg-df-bluegrey/30"></div>
                        <div class="w-2 h-2 rounded-[2px] bg-df-bluegrey"></div>
                        <div class="w-2 h-2 rounded-[2px] bg-df-aqua"></div>
                        <span>More</span>
                    </div>
                </div>
            </section>
        </div>
    `;
}
